import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'secondsToTime'
})
export class SecondsToTimePipe implements PipeTransform {
 times = {
   y: 31536000,
   mo: 2592000
  //  h: 3600,
  //  m: 60,
  //  s: 1
};
     transform(seconds) {
         console.log('Seconds', seconds);
         return  Math.floor(seconds / 12).toString() + 'y'  + ' '+ (seconds % 12).toString() + 'mo';
        
        //  let time_string: String = '';
        //  let plural: String = '';
        //  for (const key in this.times) {
        //      if (Math.floor(seconds / this.times[key]) > 0) {
        //          if (Math.floor(seconds / this.times[key]) > 1 ) {
        //              // plural = 's';
        //              plural = '';
        //          } else {
        //              plural = '';
        //          }
        //                           if (key === 'y') {
        //             time_string += Math.floor((seconds / this.times[key]) ).toString() + ' ' + key.toString() + plural + ' ';
        //             seconds = seconds - this.times[key] * Math.floor(seconds / this.times[key]);
        //          } else if (key === 'mo') {
        //          time_string += Math.ceil((seconds / this.times[key]) ).toString() + ' ' + key.toString() + plural + ' ';
        //          seconds = seconds - this.times[key] * Math.floor(seconds / this.times[key]);
        //          }
        //      }
        //  }
        //  return time_string;
     }
}
